// TimeGridDay — вид «День» (M1): all-day ряд (M5) и одна колонка временной сетки.
// Google Calendar-паттерн: день = неделя с одной колонкой.
import { Box } from '@mui/material';
import type { CalendarEvent } from '@/api/calendar';
import { TimeGrid } from './TimeGrid';
import { AllDayRow } from './AllDayRow';

interface TimeGridDayProps {
  /** Локальный день для отображения. */
  day: Date;
  /** События диапазона дня (allDay — в AllDayRow, timed — в TimeGrid). */
  events: CalendarEvent[];
  /** Колбэк клика по событию (переход к detail). */
  onEventClick?: ((event: CalendarEvent) => void) | undefined;
}

/** Вид «День»: AllDayRow + TimeGrid с одной колонкой. */
export function TimeGridDay({ day, events, onEventClick }: TimeGridDayProps): JSX.Element {
  return (
    <Box>
      <AllDayRow days={[day]} events={events} onEventClick={onEventClick} />
      <TimeGrid days={[day]} events={events} onEventClick={onEventClick} />
    </Box>
  );
}
